/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetInsurancePlansErrorResponse, GetInsurancePlansResponse } from './api.schemas';

import { api } from '../util/http';

export const getInsurancesPlans = (insuranceId: string, signal?: AbortSignal) => {
  return api<GetInsurancePlansResponse>({
    url: `/api/insurances/${insuranceId}/plans`,
    method: 'GET',
    signal,
  });
};

export const getGetInsurancesPlansQueryKey = (insuranceId?: string) => {
  return [`/api/insurances/${insuranceId}/plans`] as const;
};

export const getGetInsurancesPlansQueryOptions = <
  TData = Awaited<ReturnType<typeof getInsurancesPlans>>,
  TError = GetInsurancePlansErrorResponse,
>(
  insuranceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsurancesPlans>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInsurancesPlansQueryKey(insuranceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInsurancesPlans>>> = ({ signal }) =>
    getInsurancesPlans(insuranceId, signal);

  return { queryKey, queryFn, enabled: !!insuranceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInsurancesPlans>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInsurancesPlansQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInsurancesPlans>>
>;
export type GetInsurancesPlansQueryError = GetInsurancePlansErrorResponse;

export function useGetInsurancesPlans<
  TData = Awaited<ReturnType<typeof getInsurancesPlans>>,
  TError = GetInsurancePlansErrorResponse,
>(
  insuranceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsurancesPlans>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsurancesPlans>>,
          TError,
          Awaited<ReturnType<typeof getInsurancesPlans>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetInsurancesPlans<
  TData = Awaited<ReturnType<typeof getInsurancesPlans>>,
  TError = GetInsurancePlansErrorResponse,
>(
  insuranceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInsurancesPlans>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsurancesPlans>>,
          TError,
          Awaited<ReturnType<typeof getInsurancesPlans>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetInsurancesPlans<
  TData = Awaited<ReturnType<typeof getInsurancesPlans>>,
  TError = GetInsurancePlansErrorResponse,
>(
  insuranceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsurancesPlans>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetInsurancesPlans<
  TData = Awaited<ReturnType<typeof getInsurancesPlans>>,
  TError = GetInsurancePlansErrorResponse,
>(
  insuranceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsurancesPlans>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetInsurancesPlansQueryOptions(insuranceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
